import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import IconBase from '../IconBase';
var Svg24X24MailOutline = function Svg24X24MailOutline(props) {
  return /*#__PURE__*/React.createElement(IconBase, _extends({
    viewBox: "0 0 24 24"
  }, props, {
    width: "24",
    height: "24"
  }), /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M20 16c0 1.103-.897 2-2 2H6c-1.103 0-2-.897-2-2V8q.002-.19.038-.372c.023.03.033.065.061.092l5.78 5.78a3 3 0 0 0 2.121.862 3 3 0 0 0 2.121-.862l5.78-5.78c.028-.028.038-.063.061-.092q.036.181.038.372zM18 6c.259 0 .505.053.732.143-.086.045-.172.09-.245.163l-5.78 5.78c-.363.363-1.051.363-1.414 0l-5.78-5.78c-.073-.072-.159-.117-.245-.162A2 2 0 0 1 6 6zM6 4C3.8 4 2 5.8 2 8v8c0 2.2 1.8 4 4 4h12c2.2 0 4-1.8 4-4V8c0-2.2-1.8-4-4-4z",
    clipRule: "evenodd"
  })));
};
export default Svg24X24MailOutline;